import { I18nComponente } from "@/types/gerais"

export const NovoProjetoi18n: I18nComponente = {
  "pt-BR": {
    adicionarMembros: "adicionar profissionais membros",
    adicionarTiposDeAtividades: "adicionar tipos de atividades",
    salvar: "salvar",
    salvarMesmoAssim: "salvar mesmo assim",
    cancelar: "cancelar",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    projetos: "projetos",
    novoProjeto: "novo projeto",
    membros: "membros",
    atividades: "atividades",
    cancelarCriacaoDoProjeto: "cancelar criação do projeto?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Ao cancelar você perderá todas as informações não salvas",
    naoFoiPossivelSalvar: "não foi possível salvar",
    codigoInseridoDeveSerUnicoParaTodosOsProfissionaisDoSistema: "O código inserido deve ser único para todos os profissionais do sistema",
    nomeDoProjetoNaoUnico: "o nome do projeto não é único",
    jaExisteUmProjetoComEsseNome: "Já existe um projeto com este nome, tem certeza que deseja criar outro?",
    campoCodigoDeveSerUnico: "O campo código deve ser único, entretanto já existe um(a) código com esse valor.",
    sucesso: "Sucesso!",
    projetoCriadoComSucesso: "Projeto criado com sucesso",
    naoFoiPossivelCriarAtividadesDoProjeto: "O projeto foi salvo, mas não foi possível criar suas atividades",
    erro: "Erro!",
    naoFoiPossivelCriarProjeto: "Não foi possível criar o projeto",
    projetoAtualizadoComSucesso: "Projeto atualizado com sucesso",
    naoFoiPossivelAtualizarProjeto: "Não foi possível atualizar o projeto",
    erroInesperado: "Erro inesperado",
    ocorreuUmErroAoTentarCarregarProjetoParaEdicao: "Ocorreu um erro ao tentar carregar o projeto para edição!",
    ocorreuUmErroAoTentarCarregarInformacoesParCriarUmNovoProjeto: "Ocorreu um erro ao tentar carregar informações para criar um novo projeto!",
  },
  "es-CO": {
    adicionarMembros: "agregar profesional miembros",
    adicionarTiposDeAtividades: "agregar tipos de actividades",
    salvar: "guardar",
    salvarMesmoAssim: "guardar de todos modos",
    cancelar: "cancelar",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    projetos: "proyectos",
    novoProjeto: "nuevo proyecto",
    membros: "miembros",
    atividades: "actividades",
    cancelarCriacaoDoProjeto: "¿cancelar la creación del proyecto?",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Al cancelar perderás toda la información no guardada",
    naoFoiPossivelSalvar: "no se pudo guardar",
    codigoInseridoDeveSerUnicoParaTodosOsProfissionaisDoSistema: "El código ingresado debe ser único para todos los profesionales del sistema",
    nomeDoProjetoNaoUnico: "el nombre del proyecto no es único",
    jaExisteUmProjetoComEsseNome: "Ya existe un proyecto con este nombre, ¿seguro que quieres añadir otro?",
    campoCodigoDeveSerUnico: "El campo código debe ser único, sin embargo ya existe un(a) código con ese valor.",
    sucesso: "Éxito!",
    projetoCriadoComSucesso: "Proyecto creado con éxito",
    naoFoiPossivelCriarAtividadesDoProjeto: "El proyecto fue guardado, pero no fue posible crear sus actividades",
    erro: "¡Error!",
    naoFoiPossivelCriarProjeto: "No fue posible añadir el proyecto",
    projetoAtualizadoComSucesso: "Proyecto actualizado con éxito",
    naoFoiPossivelAtualizarProjeto: "No fue posible actualizar el proyecto",
    erroInesperado: "Error inesperado",
    ocorreuUmErroAoTentarCarregarProjetoParaEdicao: "¡Ocurrió un error al intentar cargar el proyecto para edición!",
    ocorreuUmErroAoTentarCarregarInformacoesParCriarUmNovoProjeto: "¡Ocurrió un error al intentar cargar información para añadir un nuevo proyecto!",
  }
}
